import { genericCRUDService } from '../../helpers/api';

export const SERVICE_URI = '/users';
export const BASE_URI = '/api/v1/sectors';

export const { findAll, findOne, create, update, remove } = genericCRUDService(
  SERVICE_URI,
  BASE_URI,
);
